<template>
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbs">
    <v-card>
      <vue-card-title
        title="Activity Log"
        subtitle="Activity Log"
        :icon="$getIcon('mdiFileTableBoxMultipleOutline')"
      >
        <template slot="actions">
          <v-btn
            icon
            class="grey--text ma-0"
            @click="showFilters = !showFilters"
          >
            <v-icon small v-text="$getIcon('mdiFilterVariant')"></v-icon>
          </v-btn>
        </template>
      </vue-card-title>
      <v-divider></v-divider>
      <v-slide-y-transition>
        <v-row v-if="showFilters" align="center" no-gutters class="px-4">
          <v-col cols="4">
            <vue-auto-complete
              v-model="appliedFilters.id__in"
              label="Select User"
              endpoint="/api/v1/users/autocomplete/?cre_user=True"
              item-text="name"
              item-value="id"
              multiple
            ></vue-auto-complete>
          </v-col>
          <v-col md="4" cols="6">
            <filter-generator
              v-model="appliedFilters"
              :align-center="false"
              :filters="filters"
            ></filter-generator>
          </v-col>
          <v-col md="4" cols="6">
            <v-btn small color="primary" dark @click="fetchStat">
              Apply Filter
            </v-btn>
          </v-col>
        </v-row>
      </v-slide-y-transition>
      <v-card-text class="pa-0 ma-0">
        <v-data-table
          :headers="headers"
          :items="results"
          class="elevation-1"
          hide-default-footer
          disable-sort
          hide-default-header
          disable-pagination
        >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th></th>
                <th
                  v-for="heading in headers"
                  :key="heading"
                  :colspan="2"
                  class="text-center"
                >
                  {{ heading }}
                </th>
              </tr>
            </thead>
            <thead>
              <tr>
                <th>User</th>
                <template v-for="(heading, index) in headers">
                  <th :key="`${heading}-${index}-inbound`">
                    Inbound
                  </th>
                  <th :key="`${heading}-${index}-outbound`">
                    OutBound
                  </th>
                </template>
              </tr>
            </thead>
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.name">
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <a>
                        <v-avatar :size="35" v-on="on">
                          <v-img
                            :src="
                              item.picture ||
                                require(`@/static/images/info/user-default.png`)
                            "
                            alt="CRE avatar"
                          ></v-img>
                        </v-avatar>
                      </a>
                    </template>
                    <span v-text="item.name || ''"></span>
                  </v-tooltip>
                </td>
                <template v-for="(data, index) in item.medium_logs">
                  <td
                    :key="`value-${index}-inbound-${data.name}`"
                    class="text-center"
                  >
                    {{ data.inbound === 0 ? "-" : data.inbound }}
                  </td>
                  <td
                    :key="`value-${index}-outbound-${data.name}`"
                    class="text-center"
                  >
                    {{ data.outbound === 0 ? "-" : data.outbound }}
                  </td>
                </template>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </vue-page-wrapper>
</template>

<script>
import { getCurrency } from "@/utils/common";
import FilterGenerator from "@/components/common/layout_utils/FilterGenerator";

export default {
  name: "ClientValue",
  created() {
    this.fetchStat();
  },
  components: { FilterGenerator },
  data() {
    return {
      htmlTitle: "Activity Log",
      filters: [
        {
          component: "vue-date-picker",
          bind: "dateFilter",
          props: { label: "Select Date", default: 'This Month' }
        }
      ],
      breadCrumbs: [
        { text: "Reports", disabled: true },
        {
          text: `${this.$store.state.shell.currentOrganizationName}`,
          disabled: true
        }
      ],
      headers: [],
      results: [],
      showFilters: false,
      loading: false,
      appliedFilters: {}
    };
  },
  methods: {
    fetchStat() {
      let newFil = {};
      if (this.appliedFilters.id__in && this.appliedFilters.id__in.length) {
        newFil["id__in"] = this.appliedFilters.id__in.toString();
      }

      let finalFilter = {
        start_at:
          this.appliedFilters.dateFilter &&
          this.appliedFilters.dateFilter.start_date,
        end_at:
          this.appliedFilters.dateFilter &&
          this.appliedFilters.dateFilter.end_date,
        ...newFil
      };
      this.$axios
        .$get("api/v1/crm/report/activity-log/", {
          params: finalFilter
        })
        .then(response => {
          this.results = response;
          this.prepareHeader();
        });
    },
    getCurrency,
    prepareHeader() {
      if (this.results.length) {
        this.headers = this.results[0].medium_logs.map(x => x.name);
      }
    }
  }
};
</script>
